import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (n) => Number(n || 0).toLocaleString();

const KIND = {
  earn: { label: "Earned", cls: "text-emerald-300" },
  migration_earn: { label: "Migrated from coins", cls: "text-emerald-300" },
  convert: { label: "Converted to coins", cls: "text-sky-300" },
  transfer_in: { label: "Received", cls: "text-emerald-300" },
  transfer_out: { label: "Sent", cls: "text-sky-300" },
  cashout_debit: { label: "Cash-out", cls: "text-amber-300" },
  earn_reversed: { label: "Reversed", cls: "text-rose-300" },
};

function detail(r) {
  const m = r.metadata || {};
  if (r.kind === "convert") return `→ ${fmt(m.coins)} coins`;
  if (r.kind === "cashout_debit" && m.cents != null) return `≈ $${(m.cents / 100).toFixed(2)}`;
  if (r.kind === "migration_earn") return `${fmt(m.coins_converted)} coins`;
  if (r.kind === "earn" && m.gross_coins) return `${fmt(m.gross_coins)} coins gifted`;
  if (r.kind === "earn" && r.source === "cashout_reversal") return "cash-out refunded";
  if (r.kind === "transfer_in") return `from ${(m.from || "").slice(0, 8)}`;
  if (r.kind === "transfer_out") return `to ${(m.to || "").slice(0, 8)}`;
  return r.source || "";
}

// Creator Dashboard → Bamboo: recent ledger rows (earn / convert / transfer / cash-out).
export default function BambooHistory({ refreshKey }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/bamboo/history", { params: { limit: 50 } }).then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, [refreshKey]);

  return (
    <section className="card-surface p-5" data-testid="bamboo-history">
      <div className="flex items-center gap-2 text-white mb-3"><History size={15} className="text-zinc-400" /> Recent activity</div>
      {!items ? null : items.length === 0 ? (
        <div className="text-xs text-zinc-500" data-testid="bamboo-history-empty">No 🎋 activity yet. Earn Bamboo when fans send you gifts.</div>
      ) : (
        <ul className="divide-y divide-white/5" data-testid="bamboo-history-list">
          {items.map((r) => {
            const k = KIND[r.kind] || { label: r.kind, cls: "text-zinc-300" };
            const neg = r.bamboo < 0;
            return (
              <li key={r.id} className="py-2 flex items-center gap-3 text-xs" data-testid="bamboo-history-row">
                <div className="flex-1 min-w-0">
                  <div className={`font-medium ${k.cls}`}>{k.label}</div>
                  <div className="text-[11px] text-zinc-500 truncate">{detail(r)}</div>
                </div>
                <div className={`font-display text-base tabular-nums ${neg ? "text-zinc-300" : "text-white"}`} data-testid="bamboo-history-amount">{neg ? "−" : "+"}{fmt(Math.abs(r.bamboo))} 🎋</div>
                <div className="text-[11px] text-zinc-500 w-20 text-right shrink-0">{new Date(r.created_at).toLocaleDateString(undefined, { month: "short", day: "numeric" })}</div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
